<div [ngClass]="{'sub': isSub}" class="warp">
  <textarea autoresize placeholder="{{'questionBoard.edit.placeholder' | translate}}" [formControl]="answer" ></textarea>
</div>
<!-- <p class="error" *ngIf="answer.invalid">{{answer.errors|json}}</p> -->
